<div class="contentContainer">

    <!------------------------------------------------------------------------------ header -->

    <div fxLayout="row" fxLayoutAlign="space-between center" class="headerContentContainer">
        <div fxLayout="row">
            <div fxLayoutAlign="center center" class="grayLink" (click)="routeService.goBack()">
                <mat-icon class="linkIcon ft22">arrow_back</mat-icon>
            </div>
            <div>
                <h6 class="mgl10 ft500 ft16 mgb0 gray-9"> Cursos</h6>
            </div>
        </div>
        <div fxLayout="row">
            <div routerLink="/admin/form-curso" class="mgl10 sqChip ft12 ft500 backGray9 shadow20">
                Agregar
            </div>
        </div>
    </div>


    <!------------------------------------------------------------------------------ Table -->

    <div class="tableContainer">

        <table class="w-100">

            <!-- Table Header -->
            <tr class="tableHeaderContainer">
                <th>Titulo</th>
                <th>Id</th>
                <th>Instructor</th>
                <th>Empresa</th>

                <th>Categoría</th>
                <th class="w-05">PO$</th>
                <th class="w-05">Desc.</th>
                <th class="w-05">PF$</th>

                <th class="w-05">Ventas</th>
                <th class="w-05">Publicado</th>
                <th class="w-08">Creación</th>
            </tr>

            <!-- Table Data -->
            <tr *ngFor="let item of array;  let i=index">
                <td>
                    <div fxLayoutAlign="space-between">
                        <a routerLink="/curso/{{item.id}}" class="blueLink undrl ft500 ft11">{{item.titulo}}</a>
                        <mat-icon routerLink="/admin/form-curso/{{item.id}}"
                            class="mgl05 cursorPointer gray-4 ft18 linkIcon">edit
                        </mat-icon>
                    </div>
                </td>
                <td class="centertext ft11"> {{item.id}}</td>
                <td class="centertext ft11">
                    <a routerLink="/instructor/{{item.instructorId}}"
                        class="blueLink undrl ft500 ft11">{{item.instructorNombre}}</a>
                </td>
                <td class="centertext ft11">
                    <a routerLink="/empresa/{{item.empresaId}}"
                        class="blueLink undrl ft500 ft11">{{item.empresaNombre}}</a>
                </td>

                <td class="centertext ft11">{{item.categoria}}</td>
                <td class="centertext ft11">{{item.precioOriginal}}</td>
                <td class="centertext ft11">{{item.porcentajeDescuento}}%</td>
                <td class="centertext ft11">{{item.precioFinal}}</td>
                <td class="centertext ft11">{{item.cantVentas}}</td>
                <td class="centertext ft11">
                    <div fxLayoutAlign="center center">
                        <div class="sqChip ft11 backGreen5 cursorDefault" *ngIf="item.publicado==true">
                            Publicado
                        </div>
                        <div class="sqChip ft11 backYellow5 cursorDefault" *ngIf="item.publicado==false">
                           Borrador
                        </div>
                    </div>
                </td>
                <td class="centertext ft11"> 
                    <span *ngIf="item.fechaCreacion" class="ft11">{{item.fechaCreacion.toDate() | date}}</span>    
                </td>
            </tr>
        </table>
    </div>

</div>